/* eslint-disable no-nested-ternary */

import { Flex, Text } from '@tremor/react'

interface StepperProps {
    steps: string[]
    current: number
    onStepClick?: (idx: number) => void
}

export default function Stepper({ steps, current, onStepClick }: StepperProps) {
    return (
        <Flex
            justifyContent="start"
            className="flex-wrap lg:flex-nowrap gap-x-3 gap-y-2 md:gap-x-6 w-full"
        >
            {steps.map((label, idx) => {
                const active = idx === current
                const completed = idx < current
                const circle = active
                    ? 'bg-teal-600 text-white'
                    : completed
                    ? 'bg-teal-900 text-teal-200 border border-teal-700'
                    : 'bg-gray-700 text-gray-200 border border-gray-600'
                const text = active
                    ? 'text-teal-200 font-semibold'
                    : completed
                    ? 'text-teal-300'
                    : 'text-gray-300'
                return (
                    <Flex
                        key={label}
                        alignItems="center"
                        justifyContent="start"
                        className="cursor-pointer select-none"
                        onClick={() => onStepClick && onStepClick(idx)}
                    >
                        <div
                            className={`w-5 h-5 md:w-6 md:h-6 rounded-full flex items-center justify-center ${circle}`}
                        >
                            {idx + 1}
                        </div>
                        <Text className={`ml-2 text-sm md:text-base ${text}`}>
                            {label}
                        </Text>
                    </Flex>
                )
            })}
        </Flex>
    )
}
